import React from 'react';
import { Link, Routes, Route, useLocation } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { FaBars } from 'react-icons/fa'
import { Auth, API } from 'aws-amplify';

import janus_logo from '../media/white_janus_logo.png'
import HomePage from './Models/NoModel/HomePage'
import AERMODPage from "./Models/AERMOD/AERMODPage";
import SCICHEMPage from "./Models/SCICHEM/SCICHEMPage";
import CMAQPage from "./Models/CMAQ/CMAQPage";
import STREAM_LATLpage from "./Models/STREAM_LATL/STREAM_LATLPage";
import STREAM_ICECHIPpage from "./Models/STREAM_ICECHIP/STREAM_ICECHIPPage";
import WRFPage from "./Models/WRF/WRFPage";

/*
    name: Name of the model with correct capitalization
    linkTo: Route for the model, with the same capitalization as the name
    label: The name/description to display to the User
*/
const modelMenuList = [
    {
        name: 'default',
        linkTo: '/',
        label: 'Home'
    }, {
        name: 'AERMOD',
        linkTo: '/AERMOD',
        label: 'AERMOD'
    }, {
        name: 'CMAQ',
        linkTo: '/CMAQ',
        label: 'CMAQ'
    }, {
        name: 'SCICHEM',
        linkTo: '/SCICHEM',
        label: 'SCICHEM'
    }, {
        name: 'STREAM_LATL',
        linkTo: '/STREAM_LATL',
        label: 'Stream Learn At Lunch Recordings'        
    }, {
        name: 'STREAM_ICECHIP',
        linkTo: '/STREAM_ICECHIP',
        label: 'Stream ICECHIP Videos'        
    }, {
        name: 'WRF',
        linkTo: '/WRF',
        label: 'WRF'        
    }
]


class AuthLandingPage extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            currentAuth: null,
            modelMenuOpen: false,
            model: 'default',
            availablemodels: {},
            memdate: '',
            aermodAllowances: null,
            aermodTotalAllowances: 0,
            scichemAllowances: null,
            scichemTotalAllowances: 0,
            wrfAllowances: null,
            wrfTotalAllowances: 0

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleToggle() {
        this.setState(state => ({ modelMenuOpen: !state.modelMenuOpen }));
    }

    handleClose(event) {
        if (this.anchorEl.contains(event.target)) {
            return;
        }

        let model = this.state.model
        if (event.target.attributes.model){
            model = event.target.attributes.model.value
        }

        this.setState({
            modelMenuOpen: false,
            model: model
        });
    }

    componentDidMount() {
        Auth.currentAuthenticatedUser().then(user => {
            this.setState({currentAuth: user.attributes});
        }).catch(err => console.log(err))

        // Make sure the correct topbar shows up after a page reload
        const path = window.location.pathname;
        if (path === '/'){
            this.setState({ model: 'default' })
        } else {
            this.setState({ model: path.split('/')[1]})
        }
        this.api_get_availablemodels()
        this.api_get_availableMetSets()
    }

    api_get_availablemodels() {
        let options = {
            headers: {},
            response: true
        }

        API.get("AQcast", "/request/availablemodels/", options)
            .then(response => {
                this.setState({ availablemodels: response.data.models})
            })
            .catch(error => console.log(error))
    }

    api_get_availableMetSets() {
        let options = {
            headers: {},
            response: true
        }

        API.get("AQcast", "/request/availableMetSets/", options)
            .then(response => {
                this.setState({ memdate: response.data.memdate})
                this.setState({ aermodAllowances: response.data.aermodAllowances})
                this.setState({ aermodTotalAllowances: response.data.aermodTotalAllowances})
                this.setState({ scichemAllowances: response.data.scichemAllowances})
                this.setState({ scichemTotalAllowances: response.data.scichemTotalAllowances})
                this.setState({ wrfAllowances: response.data.wrfAllowances})
                this.setState({ wrfTotalAllowances: response.data.wrfTotalAllowances})                
            })
            .catch(error => console.log(error))
    }

    fillTopNav() {

    }

    render() {
        const { modelMenuOpen } = this.state;
        const { classes } = this.props;

        return (
            <div style={{height: '100vh'}}>
                <div id='topbar' className='topbar'>
                    <Button
                        className={classNames(classes.margin, classes.buttonTheme)}
                        style={{float: 'left', fontSize:'32px'}}
                        variant="outlined"
                        size='small'
                        buttonRef={node => {
                            this.anchorEl = node;
                        }}
                        aria-owns={modelMenuOpen ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={this.handleToggle}
                        >
                        <FaBars style={{color:'white'}}/>
                    </Button>

                    <img src={janus_logo} alt="" style={{ paddingTop: '5px', width: '300', height: '44px', margin: 'auto'}}/>

                    <Popper open={modelMenuOpen} anchorEl={this.anchorEl} transition disablePortal>
                       {({ TransitionProps, placement }) => (
                           <Grow
                               {...TransitionProps}
                               id="menu-list-grow"
                               style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                               >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <MenuList>
                                        {modelMenuList.map(model => {
                                                if (this.state.availablemodels[model.name] === true || model.name === 'default'){
                                                    return (
                                                        <MenuItem
                                                            key={modelMenuList+model.name}
                                                            model={model.name}
                                                            onClick={this.handleClose}
                                                            component={Link}
                                                            to={model.linkTo}
                                                        > {model.label} </MenuItem>)
                                                }
                                                return null
                                            })}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                         </Grow>
                       )}
                    </Popper>
                    <div style={{float: 'right'}}>
                        <span style={{fontSize:'18px', padding:'15px 5px 15px 5px'}}>Welcome {this.state.currentAuth ? this.state.currentAuth.email : null}</span>
                        <Button 
                            className={classNames(classes.margin, classes.buttonTheme)}
                            style={{fontSize: '16px'}}
                            variant='outlined'
                            onClick={() => Auth.signOut()}
                            >
                            Sign out
                        </Button>
                    </div>
                    
                </div>
                <Routes>
                    <Route path='*' element={
                        <HomePage 
                            modelmenulist={modelMenuList}
                            availablemodels={this.state.availablemodels}
                            memdate={this.state.memdate}
                            aermodAllowances={this.state.aermodAllowances}
                            aermodTotalAllowances={this.state.aermodTotalAllowances}
                            scichemAllowances={this.state.scichemAllowances}
                            scichemTotalAllowances={this.state.scichemTotalAllowances}
                            wrfAllowances={this.state.wrfAllowances}
                            wrfTotalAllowances={this.state.wrfTotalAllowances}
                        />
                    }/>
                    <Route path='/AERMOD/*' element={<AERMODPage />}/>
                    <Route path='/SCICHEM/*' element={<SCICHEMPage />}/>
                    <Route path='/CMAQ/*' element={<CMAQPage />}/>
                    <Route path='/STREAM_LATL/*' element={<STREAM_LATLpage />}/>
                    <Route path='/STREAM_ICECHIP/*' element={<STREAM_ICECHIPpage />}/>      
                    <Route path='/WRF/*' element={<WRFPage />}/>                  
                    <Route path='*' element={<HomePage />}/>
                </Routes>
            </div>
        );
    }
}

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    root: {
        display: "flex",
        flexWrap: "wrap"
    },
    margin: {
        margin: theme.spacing.unit
    } ,
    withoutLabel: {
        marginTop: theme.spacing.unit * 3
    },
    textField: {
        flexBasis: 200
    },
    buttonTheme: {
        margin: 3,
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
    }
});

export default withStyles(styles)(AuthLandingPage);
